import Menu from './Menu';
import MenuItem from './MenuItem';
import SubMenu from './SubMenu';
import MenuItemGroup from './MenuItemGroup';
import { useFullPath as useOriginFullPath } from './context/PathContext';
import Divider from './Divider';
/** @private Only used for antd internal. Do not use in your production. */

var useFullPath = useOriginFullPath;
export { SubMenu, MenuItem as Item, MenuItem, MenuItemGroup, MenuItemGroup as ItemGroup, Divider, useFullPath };
var ExportMenu = Menu;
ExportMenu.Item = MenuItem;
ExportMenu.SubMenu = SubMenu;
ExportMenu.ItemGroup = MenuItemGroup;
ExportMenu.Divider = Divider;
export default ExportMenu;


//////////////////
// WEBPACK FOOTER
// ./node_modules/kts-components-antd-x4/node_modules/rc-menu/es/index.js
// module id = 268
// module chunks = 0